import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import { GET_PUBLIC_AUTH_SETTINGS_QUERY } from '../../graphql/settings'
import { getEnvironment } from '../environment'

// Configure a basic link without authentication
const publicClient = new ApolloClient({
  link: new HttpLink({
    uri: process.env.REACT_APP_STUDENT_API_GQL_URI // Make sure to set this URI in your .env file
  }),
  cache: new InMemoryCache()
})

// Example query to get `publicSettings`
const getPublicSettings = async () => {
  try {
    const { data } = await publicClient.query({
      query: GET_PUBLIC_AUTH_SETTINGS_QUERY,
      variables: { environment: getEnvironment() }
    })
    return data.publicSettings
  } catch (error) {
    return null
  }
}

export default getPublicSettings
